// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';
import {getDefaultState} from '../state';

const updateShowMoreGroupsVisibility = (state, action) => action.isMoreSummaryVisible;

export default (state = getDefaultState().isMoreSummaryVisible, action) => {

    const actionTypes = {
        [actions.UPDATE_HOME_PAGE_LABOR_ADDITIVE_SHOW_MORE_GROUPS_VISIBILITY]: updateShowMoreGroupsVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/home-page/reducers/show-more-groups-visibility.js